export default class RFQAmendStatus {
  constructor(rfq, userId) {
    this.rfqId = rfq.id;
    this.status = 'ENDED';
    this.userId = userId;
  }
}
